// @givmo/app-admin — binds the company sign-up funnel to THIS host (EP-MNT8).
//
// The funnel's screens moved into `@givmo/employer-module` so the company console renders the same
// ones; they ask their host for its auth, its address book, its look, its words and its frame. The
// portal answers with this app's auth context, `AUTH_ROUTES`, the register of its own sign-in chooser
// (EP-WEB43; until then the funnel kept the Flutter port's look), its own words and its split auth
// shell. The router wraps the `/sign-up` door and the sign-up flow's layout in it
// (`router/routes.tsx`).

import { useMemo, type ReactNode } from 'react';
import {
  PORTAL_SIGN_UP_LOOK,
  PORTAL_SIGN_UP_PATHS,
  PORTAL_SIGN_UP_WORDS,
  SignUpHostProvider,
  type SignUpHost,
} from '@givmo/employer-module';
import { useAuth } from '../../auth/auth-context';
import { AuthShell } from './auth-shell';

export function PortalSignUpHost({ children }: { children: ReactNode }) {
  const auth = useAuth();
  const host = useMemo<SignUpHost>(
    () => ({
      auth,
      paths: PORTAL_SIGN_UP_PATHS,
      look: PORTAL_SIGN_UP_LOOK,
      words: PORTAL_SIGN_UP_WORDS,
      Shell: AuthShell,
    }),
    [auth],
  );
  return <SignUpHostProvider host={host}>{children}</SignUpHostProvider>;
}
